import { datadogRum } from "@datadog/browser-rum";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { IconButton, Menu, MenuItem, TableCell, TableRow } from "@mui/material";
import { getNavOrgKitchenMenuScheduleImport } from "apps/web/src/pages/Auth/Org/Kitchen/KitchenPaths";
import React from "react";
import { useNavigate } from "react-router-dom-v5-compat";
import { getNavOrgMenuBuilder } from "../../../pages/Auth/Org/MenuBuilder/MenuBuilderPaths";
import { usePlannedMenuTable } from "./PlannedMenuTableProvider";

export const PlannedMenuRows = () => {
  const navigate = useNavigate();
  const {
    rows,
    moreInfo,
    setMoreInfo,
    setDeletablePlannedMenu,
    setMenuToDuplicate,
    setMenuToEdit,
    getFormattedNameForUser,
    getFormattedDateRange,
  } = usePlannedMenuTable();

  return (
    <>
      {rows.map(row => {
        const { id, name, description, mealTypes, createdBy, startDate, endDate, timezone } = row;
        return (
          <TableRow
            id={id}
            key={id}
            hover
            sx={{ cursor: "pointer" }}
            onClick={() => navigate(getNavOrgMenuBuilder(id))}>
            <TableCell>{name}</TableCell>
            <TableCell>{description}</TableCell>
            <TableCell>{mealTypes.join(", ")}</TableCell>
            <TableCell>{createdBy && getFormattedNameForUser(createdBy)}</TableCell>
            <TableCell>{getFormattedDateRange({ startDate, endDate, timezone })}</TableCell>

            <TableCell sx={{ display: "flex" }}>
              <IconButton
                size="small"
                onClick={e => {
                  e.stopPropagation();
                  setMoreInfo({ moreAnchorElement: e.currentTarget, plannedMenu: row });
                }}
              >
                <MoreVertIcon />
              </IconButton>
            </TableCell>
          </TableRow>
        );
      })}
      <Menu
        anchorEl={moreInfo?.moreAnchorElement}
        open={!!moreInfo}
        onClose={() => {
          setMoreInfo(null);
        }}
        keepMounted
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        {moreInfo && (
          <>
            <MenuItem
              dense
              onClick={() => {
                setMenuToEdit(moreInfo.plannedMenu);
                setMoreInfo(null);
              }}
            >
              Edit menu details
            </MenuItem>

            <MenuItem
              dense
              onClick={() => {
                datadogRum.addAction("menu_builder.table.clicked_publish_menu", { menuId: moreInfo.plannedMenu.id });
                setMoreInfo(null);
                navigate(getNavOrgKitchenMenuScheduleImport(moreInfo.plannedMenu.startDate, moreInfo.plannedMenu.id));
              }}
            >
              Publish
            </MenuItem>

            <MenuItem
              dense
              onClick={() => {
                setMenuToDuplicate(moreInfo.plannedMenu);
                setMoreInfo(null);
              }}
            >
              Duplicate
            </MenuItem>

            <MenuItem
              dense
              onClick={() => {
                setDeletablePlannedMenu(moreInfo.plannedMenu);
                setMoreInfo(null);
              }}
            >
              Delete
            </MenuItem>
          </>
        )}
      </Menu>
    </>
  );
};
